export class PolicyHolderService {

  public static CommoditiesEffectiveDatePhase1 = new Date('06/01/2025');
  public static CommoditiesEffectiveDatePhase2 = new Date('07/01/2025');

  public static CommoditiesEligibleStatesPhase1: Array<string> = [
    'AL', 'AR', 'AZ', 'DE', 'FL', 'GA', 'IA', 'IL', 'IN', 'KS', 'MD', 'ME', 'MI', 'MN', 'MO', 'MS',
    'ND', 'NH', 'NM', 'NV', 'OK', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'WI', 'WV', 'ID', 'KY', 'NC', 'NE', 'OR', 'LA', 'CO'
  ];

  public static CommoditiesEligibleStatesPhase2: Array<string> = ['OH'];
 
  public static NewCommodities: Array<string> = [
    "ATV's AND GOLF CARTS",
    "ASPHALT - HOT", 
    "ASPHALT - NOT HOT", 
    "BULK FERTILIZER",
    "BAGGED FERTILIZER", 
    "COSMETICS AND PERFUME",
    "CHEMICALS - NON ACIDIC, NON CORROSIVE, NON FLAMMABLE, AND NON EXPLOSIVE", 
    "CHEMICALS - ACIDIC, CORROSIVE, FLAMMABLE, OR EXPLOSIVE", 
    "DIRT, SAND, GRAVEL AND ROCK",
    "FOOD & BEVERAGES NON REFRIGERATED", 
    "LITHIUM BATTERIES", 
    "MARBLE/GRANITE/OTHER STONE SLABS", 
    "MINERALS NON-PRECIOUS",
    "MUSICAL INSTRUMENTS", 
    "OTHER METALS",
    "PETROLEUM PRODUCTS 140 - 200 DEGREES FLASHPOINT",
    "PETROLEUM PRODUCTS OVER 200 DEGREES FLASHPOINT", 
    "PRODUCE", 
    "RV’S", 
    "TV RADIO STEREO CELL PHONE OTHER PERSONAL ELECTRONIC EQUIPMENT",
    "WIRE NOT FIBER OPTIC",
    "WOOD PRODUCTS NOT FURNITURE AND CASKETS", 
    "ZINC"
  ];
 
  public static ExsistingCommodities: Array<string> = [
    "ASPHALT",
    "CHEMICALS - NON ACIDIC",
    "CHEMICALS - NON CORROSIVE", 
    "CHEMICALS - NON FLAMMABLE/ NON EXPLOSIVE", 
    "COSMETICS AND PERFURME", "EQUIPMENT",
    "FRUITS", 
    "GRAVEL & ROCK",
    "MARBLE/GRANITE/OTHER STONE SLABS 0605",
    "MINERALS NONPRECIOUS", 
    "MUSICAL INSTRUMENTS 0809",
    "OTHER CHEMICALS", 
    "OTHER FOOD & BEVERAGES",
    "OTHER METALS / COAL", 
    "POWER TOOLS", 
    "RAW FURS", 
    "RV'S GOLF CARTS", 
    "TV RADIO STEREO CELL PHONE OTHER PERSONAL ELECTRONIC", 
    "VEGETABLES"
  ];
 
  public static InEligibleCommoditiesForNewVersion: Array<string> = [
    "COAL", 
    "DANGEROUS ARTICLES, EXPLOSIVES, CORROSIVES, FLAMMABLES, ACIDS", 
    "GARBAGE", 
    "LITHIUM BATTERIES", 
    "LOGS", 
    "MARBLE/GRANITE/OTHER STONE SLABS",
    "PETROLEUM PRODUCTS 140 - 200 DEGREES FLASHPOINT", 
    "PETROLEUM PRODUCTS OVER 200 DEGREES FLASHPOINT", 
    "SEAFOOD (FRESH)", 
    "TIRES"
  ];

   public static InvalidCommoditiesForMTC: Array<string> = [
    "CATTLE", 
    "OTHER LIVESTOCK", 
    "POULTRY (LIVE)", 
    "SCRAP METAL", 
    "SEAFOOD (FRESH)", 
    "SWINE"
  ];
}